/** @jsxImportSource @emotion/react */
import { Box, Divider, Paper, Theme, Typography, useTheme } from '@mui/material';
import { config } from 'application';
import React from 'react';
import { useIntl } from 'react-intl';
import { StylesClassName, UseStyles } from 'types/styles';

interface NewsItemProps {
  className?: StylesClassName;
  title: string;
  date: string;
  url: string;
  img: string;
}

const NewsItem: React.FC<NewsItemProps> = ({ className, title, date, url, img, ...rest }) => {
  const theme = useTheme() as Theme;
  const classes = useStyles(theme);
  const { formatDate } = useIntl();

  return (
    <Box component="a" href={url} target="_blank" css={classes.link}>
      <Paper css={[classes.NewsItem, className]} {...rest}>
        <Box css={classes.img}>
          <img src={img} alt="" />
        </Box>
        <Divider />
        <Box css={classes.content} p={4}>
          <Typography mb={3} component="div" variant="body1" css={classes.title} className="newsItem-title">
            {title}
          </Typography>
          <Typography component="div" mt={3} css={classes.date}>
            {formatDate(date, config.dateFormat)}
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

const useStyles = (theme: Theme): UseStyles => ({
  NewsItem: {
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',

    '&:hover': {
      boxShadow: '0px 2px 10px -2px rgba(0, 32, 92, 0.2)',
    },
  },
  link: {
    textDecoration: 'none',
    display: 'flex',
    height: '100%',
  },
  img: {
    img: {
      display: 'block',
      width: '100%',
      height: 'auto',
      aspectRatio: '265 / 200',
      objectFit: 'cover',
      objectPosition: 'center center',
    },
  },
  title: {
    fontWeight: 600,
    color: theme.palette.custom.primary.brand[120],
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  date: {
    marginTop: 'auto',
    color: theme.palette.custom.primary.grey[100],
  },
});

export default NewsItem;
